import StartSpinerBlock from './start-spiner-block';
export default StartSpinerBlock;